"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var indicator_framework_service_1 = require("./indicator-framework.service");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var core_1 = require("@angular/core");
var path_helper_1 = require("./config/path.helper");
var dummy_me_entity_search_service_1 = require("./dummy-me-entity-search.service");
var from_1 = require("rxjs/observable/from");
var operators_1 = require("rxjs/operators");
/**
 * Created by gevorg.avetisyan on 4/27/2018.
 */
var HttpIndicatorFrameworkService = /** @class */ (function (_super) {
    __extends(HttpIndicatorFrameworkService, _super);
    function HttpIndicatorFrameworkService(http, applicationPropertiesService) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.applicationPropertiesService = applicationPropertiesService;
        _this.meServiceUriKey = "me-de-service-url";
        _this.meServiceUri$ = from_1.from(_this.applicationPropertiesService.getProperty(_this.meServiceUriKey));
        return _this;
    }
    HttpIndicatorFrameworkService.prototype.saveFrameworkIndicatorByIFSystemNameAndIFItemId = function (indicatorIds, rfId, rfItemId, rfLevel, systemName, ifItemId) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) {
            return _this.http.post(url + path_helper_1.PathHelper.FRAMEWORK_INDICATORS + (rfId + "/" + rfItemId + "/" + rfLevel + "/" + systemName + "/" + ifItemId), indicatorIds);
        }));
    };
    HttpIndicatorFrameworkService.prototype.saveFrameworkIndicator = function (indicatorIds, rfId, rfItemId, rfLevel) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.post(url + path_helper_1.PathHelper.FRAMEWORK_INDICATORS + (rfId + "/" + rfItemId + "/" + rfLevel), indicatorIds); }));
    };
    HttpIndicatorFrameworkService.prototype.saveIFrameworkIndicator = function (indicatorIds, systemName, ifItemId) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.post(url + path_helper_1.PathHelper.FRAMEWORK_INDICATORS + (ifItemId + "/" + systemName), indicatorIds); }));
    };
    HttpIndicatorFrameworkService.prototype.deleteFrameworkIndicatorByIFSystemNameAndIFItemId = function (indicatorId, rfId, rfItemId, rfLevel, systemName, ifItemId) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) {
            return _this.http.delete(url + path_helper_1.PathHelper.FRAMEWORK_INDICATORS + (indicatorId + "/" + rfId + "/" + rfItemId + "/" + rfLevel + "/" + systemName + "/" + ifItemId));
        }));
    };
    HttpIndicatorFrameworkService.prototype.deleteFrameworkIndicator = function (indicatorId, rfId, rfItemId, rfLevel) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.delete(url + path_helper_1.PathHelper.FRAMEWORK_INDICATORS + (indicatorId + "/" + rfId + "/" + rfItemId + "/" + rfLevel)); }));
    };
    HttpIndicatorFrameworkService.prototype.deleteIndicatorAssignedIF = function (indicatorId, ifItemId, ifSystemName) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.delete(url + path_helper_1.PathHelper.FRAMEWORK_INDICATORS + (indicatorId + "/" + ifSystemName + "/" + ifItemId)); }));
    };
    HttpIndicatorFrameworkService.prototype.getAssignedIndicatorsByIFSystemNameAndIFItemId = function (rfId, rfItemId, rfLevel, systemName, ifItemId) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) {
            return _this.http.get(url + path_helper_1.PathHelper.FRAMEWORK_INDICATORS + (rfId + "/" + rfItemId + "/" + rfLevel + "/" + systemName + "/" + ifItemId));
        }));
    };
    HttpIndicatorFrameworkService.prototype.getAssignedIndicators = function (rfId, rfItemId, rfLevel) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.get(url + path_helper_1.PathHelper.FRAMEWORK_INDICATORS + (rfId + "/" + rfItemId + "/" + rfLevel)); }));
    };
    HttpIndicatorFrameworkService.prototype.getIndicatorWithFrameworks = function (indicatorIds) {
        var _this = this;
        var params = { iids: dummy_me_entity_search_service_1.Convert.convertNumberArrayToString(indicatorIds, ",") };
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.get(url + path_helper_1.PathHelper.FRAMEWORK_INDICATORS, { params: params }); }));
    };
    HttpIndicatorFrameworkService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_authentication_client_js_1.HttpClientWrapper, idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], HttpIndicatorFrameworkService);
    return HttpIndicatorFrameworkService;
}(indicator_framework_service_1.IndicatorFrameworkService));
exports.HttpIndicatorFrameworkService = HttpIndicatorFrameworkService;
//# sourceMappingURL=http-indicator-framework.service.js.map